import { render, staticRenderFns } from "./CronDetails.vue?vue&type=template&id=f18e0c24"
import script from "./CronDetails.vue?vue&type=script&lang=js"
export * from "./CronDetails.vue?vue&type=script&lang=js"
import style0 from "./CronDetails.vue?vue&type=style&index=0&id=f18e0c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports